export default "__VITE_ASSET__cf3bd7c6__"